// extracted by mini-css-extract-plugin
export default {"hd":"MiddleSection_hd__jliBf","tx1":"MiddleSection_tx1__-QhFN","tx2":"MiddleSection_tx2__57Qz5","tx3":"MiddleSection_tx3__LXhPW"};